import { render, staticRenderFns } from "./DataInspection.vue?vue&type=template&id=94bb4830&scoped=true&"
import script from "./DataInspection.vue?vue&type=script&lang=js&"
export * from "./DataInspection.vue?vue&type=script&lang=js&"
import style0 from "./DataInspection.vue?vue&type=style&index=0&id=94bb4830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bb4830",
  null
  
)

export default component.exports